export const MIN_ITEMS_FOR_NON_DRAFT_IDEALIST = 2;
export const IDEALISTS_PER_PAGE = 20;
